import styled from "styled-components";
import { Switch } from "antd";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;

export const StyledSwitch = styled(Switch)`
  &.ant-switch-checked {
    background: #11a7d9;

    &:hover:not(.ant-switch-disabled) {
      background: #0f97c4;
    }
  }
`;

export const LabelText = styled.span`
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const TooltipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
`;
